
import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { Sgke141aRequest, Sgke141aResponse, Sgke141aService } from 'sg-api';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';

@Injectable({
  providedIn: 'root'
})
export class UsedSgke141aService {

  /**
   * コンストラクタ
   * @param {Sgke141aService} service
   * @param {ApiCommonService} apiCommonService
   * @param {FeaturesLibConfig} featuresLibcComfig
   * @memberof UsedSgke141aService
   */
  constructor(
    public service: Sgke141aService,
    public apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibcComfig: FeaturesLibConfig
  ) { }

  /**
   * SGKE141A_手数料報告初期表示（作業管理）API呼び出し
   * @param {Sgke141aRequest} request 
   * @returns {Observable<Sgke141aResponse>}
   * @memberof UsedSgke141aService
   */
  public doSgke141a(request: Sgke141aRequest): Observable<Sgke141aResponse> {
    return this.service.sgke141aPost(this.apiCommonService.setRequestCommon(<any>request), 'response')
      .pipe(
        map(
          response => {
            // エラーが設定されていないかチェックする
            this.apiCommonService.checkError(response);
            return response.body;
          }),
        timeout(Number(this.featuresLibcComfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKE141A');
          return throwError(err.message);
        })
      );
  }

}
